import { IaController } from './ia.controller'

/* @ngInject */
function routes ($stateProvider, $urlRouterProvider) {
  const checkModuleEnabled = [
    '$rootScope',
    '$q',
    '$state',
    ($rootScope, $q, $state) => {
      const deferred = $q.defer()

      $rootScope.getUser().then((user) => {
        const hasAccess = $rootScope.isUserSysAdminAdminDesigner(user)

        if (hasAccess) {
          deferred.resolve()
        } else {
          deferred.reject()
        }
      })

      return deferred.promise
        .catch(() => {
          $state.go('home')
        })
    }
  ]
  $stateProvider
    .state('ia', {
      url: '/ia',
      views: {
        '': {
          templateUrl: '/ia/ia.html?$$REVISION$$',
          controller: IaController
        }
      },
      resolve: {
        checkModuleEnabled
      }
    })

  $urlRouterProvider.when('/ia/', '/ia')
}

export const iaRoutes = routes
